import {Location} from "@angular/common";
import {Component, Inject, OnInit} from "@angular/core";
import {contextPath} from "site";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {AircraftFormComponent} from "./aircraft-form.component";
import {AddAircraft, AircraftService} from "../aircraft.service";
import {DealerAircraftService} from "../../dealer-customer-management/dealer-aircraft.service";
import {Observable} from "rxjs";
import {Response} from "@angular/http";
import { OrgService } from "./org.service";

@Component({
	selector: "add-aircraft",
	template: `
		<div class="page-message page-message-warning mt-2" *ngIf="this.isDealerUser && !isDealerCustomerManagementFlow">
			Important: Use the <a href="{{contextPath}}/dealer/customer-management/">Manage Customer Account</a>
			function if editing an existing customer aircraft.
		</div>

		<h1 *ngIf="!this.isDealerCustomerManagementFlow">Add Your Aircraft</h1>
		<h1 *ngIf="this.isDealerCustomerManagementFlow">Add Customer's Aircraft</h1>
		<button class="backbutton" (click)="navigateBack()">
			<i class="backbutton_icon fa fa-angle-left fa-lg"></i>Back
		</button>

		<!---------- FORM BEGINS ---------->
		<form [formGroup]="aircraftForm" (ngSubmit)="onSubmit()" novalidate>

			<!---------- NEW AIRCRAFT FORM ---------->
			<div class="adddevicesection">
				<aircraft-form [aircraftFormGroup]="aircraftFormGroup"> </aircraft-form>
			</div>

			<!---------- SUBMIT / CANCEL BUTTONS ---------->
			<div class="form_submitsection">
				<button class="button button-primary button-large" [disabled]="!aircraftForm.valid || submitting">{{ getSubmitButtonText() }}</button>
				<button class="button-link button-large" type="button" (click)="navigateBack()">Cancel</button>
			</div>
		<!---------- FORM ENDS ---------->
		</form>

	`,
})
export class AddAircraftComponent implements OnInit {
	// Device and aircraft form
	aircraftForm: FormGroup;
	submitting = false;
	contextPath = contextPath;
	isDealerUser: boolean;
	isDealerCustomerManagementFlow: boolean;
	private customerGuid: string = null;

	constructor(
		@Inject("isDealerUser") isDealerUser: boolean,
		private location: Location,
		private aircraftService: AircraftService,
		private dealerAircraftService: DealerAircraftService,
		private orgService: OrgService,
		private router: Router,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute
	) {
		this.isDealerUser = isDealerUser;
	}

	ngOnInit() {
		this.route.paramMap.subscribe((routeParams: ParamMap) => {
				this.customerGuid = routeParams.get("customer-uuid");
			},
		);
		this.isDealerCustomerManagementFlow = this.isDealerUser && this.customerGuid != null;
		this.createForm();
	}

	navigateBack() {
		this.location.back();
	}

	navigateToAircraft(aircraftID: string) {
		let commands: any[] = this.isDealerCustomerManagementFlow ? ["customer/", this.customerGuid, "aircraft", aircraftID] : ["aircraft/", aircraftID];
		this.router.navigate(commands);
	}

	private createForm() {

		this.aircraftForm = this.isDealerCustomerManagementFlow
			? this.formBuilder.group({
				aircraftFormGroup: AircraftFormComponent.createDealerFormGroup({}, this.customerGuid, this.dealerAircraftService, false, null),
			})
			: this.formBuilder.group({
				aircraftFormGroup: AircraftFormComponent.createFormGroup({}, this.aircraftService, false, null),
			});
	}


	getSubmitButtonText(): string {
		if (this.submitting) {
			return "Adding";
		}
		else {
			return "Add Aircraft";
		}
	}

	onSubmit() {
		const aircraft: AddAircraft = {
			id: this.aircraftFormGroup.get("aircraftRegistration").value.trim(),
			name: this.aircraftFormGroup.get("aircraftName").value.trim(),
			serial: this.aircraftFormGroup.get("aircraftSerial").value.trim().toUpperCase(),
			aircraftModelId: this.aircraftFormGroup.get("aircraftModelId").value,
			year: this.aircraftFormGroup.get("aircraftYear").value
		};

		if (this.orgService.uuid !== "") {
			aircraft.organizationUuid = this.orgService.uuid;
		}

		this.submitting = true;
		let addAircraft$: Observable<Response> = this.isDealerCustomerManagementFlow
			? this.dealerAircraftService.addAircraft(aircraft, this.customerGuid)
			: this.aircraftService.addAircraft(aircraft);
		addAircraft$
			.subscribe(
				response => {
					if ([200, 201].includes(response.status)) {
						let url = response.headers.get("Location");
						let identifier = url ? url.substring(url.lastIndexOf("/") + 1) : aircraft.id;
						this.navigateToAircraft(identifier);
					} else {
						this.submitting = false;
						throw response;
					}
				},
				error => {
					this.submitting = false;
					throw error;
				});
	}

	// Provide easier access to the form controls within the view (for displaying validation errors)
	get aircraftSelection() { return this.aircraftForm.get("aircraftSelection"); }
	get aircraftFormGroup() { return this.aircraftForm.get("aircraftFormGroup"); }

}
